import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './Alanlar.css';

function Alanlar() {
  const alanVerileri = [
    {
      alan: "Örgütsel Davranış",
      koordinatorler: [
        { ad: "Prof. Dr. A. Asuman Akdoğan", kurum: "Erciyes Üniversitesi" },
        { ad: "Prof. Dr. Erkan Turan Demirel", kurum: "Fırat Üniversitesi" },
        { ad: "Doç. Dr. Ebru Özer ", kurum: "Necmettin Erbakan Üni." },
        { ad: "Doç. Dr. Ergün Kara", kurum: "Osmaniye Korkut Ata Üni." }
      ]
    },
    {
      alan: "İnsan Kaynakları Yönetimi",
      koordinatorler: [
        { ad: "Prof. Dr. Lale Kazımbek Tüzüner", kurum: "İstanbul Üniversitesi" },
        { ad: "Prof. Dr. Berrin FİLİZÖZ", kurum: "Sivas Cumhuriyet Üni." },
        { ad: "Doç.Dr. Zümral Gültekin", kurum: "Ondokuz Mayıs Üniversitesi." },

        { ad: "Doç. Dr. Meral Erdirençelebi", kurum: "Necmettin Erbakan Üni." }
      ]
    },
    {
      alan: "Stratejik Yönetim",
      koordinatorler: [
        { ad: "Prof. Dr. Mehmet Abdülkadir Varoğlu", kurum: "Başkent Üniversitesi" },
        { ad: "Prof. Dr. Esin Can", kurum: "Yıldız Teknik Üniversitesi" },
        { ad: "Doç. Dr. M. Said Döven", kurum: "Tokat Gaziosmanpaşa Üni." }
      ]
    },
    {
      alan: "Örgüt Kuramı",
      koordinatorler: [
        { ad: "Prof. Dr. Nazlı Wasti Pamuksuz", kurum: "Orta Doğu Teknik Üniversitesi" },
        { ad: "Doç. Dr. Cihat Erbil", kurum: "Hacı Bayram Veli Üni." },
        { ad: "Doç. Dr. Emrah Koparan", kurum: "Amasya Üni." },

      ]
    },
    {
      alan: "İşletme Tarihi",
      koordinatorler: [
        { ad: "Prof. Dr. Mehmet Barca", kurum: "Ankara Sosyal Bilimler Üni." },
        { ad: "Dr. Öğretim Üyesi Metin Günay", kurum: "Sivas Cumhuriyet Üni." }
      ]
    }
  ];

  return (
    <div className="alanlar-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>Alanlar ve Alan Koordinatörleri</h2>
          <p>Bilimsel Değerlendirme Sürecini Yöneten Akademisyenlerimiz</p>
        </div>
      </header>

      <main className="content-container">
        <div className="alanlar-grid">
          {alanVerileri.map((item, index) => (
            <div key={index} className="alan-card">
              <div className="alan-header">
                <h3>{item.alan}</h3>
              </div>
              <ul className="koordinator-list">
                {item.koordinatorler.map((k, i) => (
                  <li key={i}>
                    <span className="name">{k.ad}</span>
                    <span className="university">{k.kurum}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Alanlar;